<script>
import { mapActions } from "vuex";
import { required, email } from '@vuelidate/validators';
import Supplier from "@/models/Supplier.vue";

import BaseSupplierGroupDialogSelector from "@/components/shared/BaseDialogSelectors/BaseSupplierGroupDialogSelector.vue";

export default {
  extends: Supplier,
  components: {
    BaseSupplierGroupDialogSelector,
  },
  computed: {
    title() {
      return this.id ? `Edit ${this.modelName}` : `Create ${this.modelName}`;
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    ...mapActions("suppliers", ["upsertSupplier"]),
    ...mapActions("application", ["setIsConfirmLoading", "warnValidation"]),

    async show() {
      this.initialize();
      this.showModal = true;
    },

    async upsert(e) {
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.warnValidation();
        return;
      } else {
        this.setIsConfirmLoading(true);
        try {
          const res = await this.upsertSupplier(this.supplier);
          this.$emit("upserted", res.data?.data);
          this.showModal = false;
        } catch {
        } finally {
          this.setIsConfirmLoading(false);
        }
      }
    },
  },
  watch: {
    showModal() {
      this.v$.$reset();
    }
  },
  validations() {
    return this.showModal
      ? {
          name: { required },
          email: { email },
        }
      : { };
  },
};
</script>

<template>
  <base-modal v-model="showModal" :title="title" @upsert="upsert">
    <form @submit.prevent="upsert">
      <div class="row mb-2 gap-2 gap-sm-0">
        <div class="col-sm-8 col-xl-7">
          <base-input label="Name" type="text" v-model="name" :validation="v$.name" required />
        </div>
        <div class="col-sm-4 col-xl-5">
          <base-input label="Tax Number" type="text" v-model="vat_number" />
        </div>
      </div>
      <div class="row mb-2 gap-2 gap-sm-0">
        <div class="col-sm-7">
          <base-input label="Contact Person" type="text" v-model="contact_person" />
        </div>
        <div class="col-sm-5">
          <base-input label="Contact Number" type="text" v-model="contact_number" />
        </div>
      </div>
      <div class="row mb-2">
        <base-input label="Email" type="text" v-model="email" :validation="v$.email" />
      </div>
      <div class="row gap-2 gap-sm-0">
        <!-- <div class="col-sm-7"> -->
          <BaseSupplierGroupDialogSelector v-model="supplier_group" disableAdd disableModals />
        <!-- </div>
        <div class="col-sm-5">

        </div> -->
      </div>
    </form>
  </base-modal>
</template>
